if (typeof document !== 'undefined' && process.env.NODE_ENV !== 'test' && !document.head.querySelector("style[data-wp-hash='e3ae230cea']")) {
	const style = document.createElement("style");
	style.setAttribute("data-wp-hash", "e3ae230cea");
	style.appendChild(document.createTextNode("@layer wp-ui-utilities, wp-ui-components, wp-ui-compositions, wp-ui-overrides;@layer wp-ui-utilities{._336cd3e4e743482f__box-sizing{box-sizing:border-box;*,:after,:before{box-sizing:inherit}}}"));
	document.head.appendChild(style);
}
export default {"box-sizing":"_336cd3e4e743482f__box-sizing"};
